<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="critereRecherche">
    <div class="column is-12 pdb-0"
         :class="[
      {'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component :messages="errors"
                             :error="errors.length > 0"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="errors = []"/>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless"
         :class="[
           {'hauteur-brief-filtre': errors.length === 0},
           {'hauteur-brief-filtre-errors': errors.length > 0}
         ]">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 is-marginless">
          <b-field :label="$t('listeProduitFace.filtre.dateReferenceAffectation')"
                   class="obligatoire">
            <b-datepicker show-week-number
                          icon="calendar-today"
                          :editable="true"
                          position="is-bottom-right"
                          v-model="critereRecherche.dateReferenceAffectation"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeProduitEcran.filtre.reference')">
            <qd-taginput
              v-model="critereRecherche.references"
              type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0" v-if="modulePresseActive">
          <query-tag-input :label="$t('listeProduitEcran.filtre.regroupementProduit')"
            v-model="critereRecherche.regroupementProduitIds"
            :query="(search) => getAllRegroupementProduit({
              query: {
                auto: search,
                societeId: this.societeActiveId,
              },
            })">
          <template slot-scope="props">
            <div>{{ props.option.libelle }}</div>
          </template>
          </query-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeProduitEcran.filtre.adresses')">
            <qd-taginput
              v-model="critereRecherche.adresses"
              type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeProduitEcran.filtre.codePostal')">
            <qd-taginput
              v-model="critereRecherche.codesPostaux"
              type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeProduitEcran.filtre.ville')">
            <ville-tag-input-auto-complete
              :critere-recherche="this.critereRecherche"
              table-name="Produit"/>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeProduitEcran.filtre.departement')">
            <qd-taginput
              v-model="critereRecherche.departements"
              type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeProduitEcran.filtre.agglomeration')">
            <qd-taginput
              v-model="critereRecherche.agglomeration"
              type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeProduitEcran.filtre.format')">
            <qd-taginput
              v-model="critereRecherche.formats"
              type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeProduitEcran.filtre.materiel')">
            <qd-taginput
              v-model="critereRecherche.materiels"
              type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeProduitEcran.filtre.support')">
            <qd-taginput
              v-model="critereRecherche.supports"
              type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeProduitEcran.filtre.angleVision')">
            <qd-taginput
              v-model="critereRecherche.anglesVision"
              type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeProduitEcran.filtre.localisation')">
            <qd-taginput
              v-model="critereRecherche.localisations"
              type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <agence-tag-input
            :label="$t('listeProduitEcran.filtre.agence')"
            :items="filtrerProduitParAgence ? agencesSelectionnees : agencesInformations"
            v-model="critereRecherche.agencesId">
          </agence-tag-input>
        </div>
        <div class="column is-12 pdb-0" v-if="societesInformations.length > 1
          && !filtrerProduitParSociete && !filtrerProduitParAgence">
          <b-field :label="$t('listeProduitEcran.filtre.societe')">
            <b-select v-model="critereRecherche.societeId" expanded>
              <option v-for="societe in societesInformations"
                :key="societe.id"
                :value="societe.id">
                {{ societe.libelle }}
              </option>
            </b-select>
          </b-field>
        </div><div class="column is-12 pdb-0">
          <b-field :label="$t('listeProduitEcran.filtre.eclaire')">
            <b-select v-model="critereRecherche.eclaire">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false"> {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeProduitEcran.filtre.avecLiaisonsTarif')">
            <b-select v-model="critereRecherche.avecLiaisonsTarif">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false"> {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeProduitEcran.filtre.avecCoordonnees')">
            <b-select v-model="critereRecherche.avecCoordonnees">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false"> {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeProduitEcran.filtre.actif')">
            <b-select v-model="critereRecherche.actif">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false"> {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('general.button.appliquer')}}
      </button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()"
      >{{$t('general.button.reinitialiser')}}</button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { SET_CRITERES_RECHERCHE } from '@/store/modules/produitFace-mutation-type';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import genererCritereRechercheProduitEcran from '@/services/catalogue/genererCriteresRecherche/genererCritereRechercheProduitEcranNumerique';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import VilleTagInputAutoComplete from '@/components/commun/ville/villeTagInputAutoComplete';
import { getAll as getAllRegroupementProduit } from '@/api/produit/regroupementProduit';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';
import queryTagInput from '@/components/general/tagInput/queryTagInput';

const Societes = createNamespacedHelpers('societe');
const ProduitEcranNumerique = createNamespacedHelpers('produitEcranNumerique');
const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    isCartographie: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      critereRecherche: null,
      errors: [],
      getAllRegroupementProduit,
    };
  },
  components: {
    errorMsgComponent,
    VilleTagInputAutoComplete,
    agenceTagInput,
    queryTagInput,
  },
  computed: {
    ...Societes.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societesInformations: 'societesInformations',
      agencesInformations: 'agencesInformations',
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    storeName() {
      return this.isCartographie ? 'produitEcranCartographie' : 'produitEcranNumerique';
    },
    critereRechercheFromStore: {
      get() {
        return this.$store.getters[`${this.storeName}/criteresRecherche`];
      },
      set(value) {
        this.$store.commit(`${this.storeName}/SET_CRITERE`, value);
      },
    },
    filtrerProduitParSociete() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key);
    },
    filtrerProduitParAgence() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key);
    },
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
  },
  methods: {
    ...ProduitEcranNumerique.mapMutations({
      setCritereRecherche: SET_CRITERES_RECHERCHE,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    setCritereRecherche(critere) {
      return this.$store.commit(`${this.storeName}/${SET_CRITERES_RECHERCHE}`, critere);
    },
    viderCritere() {
      this.critereRecherche = cloneDeep(genererCritereRechercheProduitEcran(this.isCartographie));
    },
    appliquerCritere() {
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadParametresInterne([
          PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key,
          PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key,
          PARAMETRES_INTERNE_KEYS.modulePresse.key,
        ]);
        this.critereRecherche = cloneDeep(this.critereRechercheFromStore);
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
